import React from 'react';
import { PropTypes } from 'prop-types';
import { Field, useField } from 'formik';
import classNames from 'classnames';

// https://formik.org/docs/examples/checkboxes
// This supports single checkboxes - no value, different names
// and group checkboxes with the same name, different values
const Checkbox = ({ name, label, value, onChange = () => {}, disabled }) => {
    const id = value ? `checkbox-${value}` : `checkbox-${name}`;
    const [field, meta, helpers] = useField(name);
    const labelClasses = classNames('form-check-label', {
        'form-check-label--disabled': disabled,
    });

    return (
        <div className="form-check">
            <label className={labelClasses} htmlFor={id}>
                <Field
                    id={id}
                    className="form-check-input"
                    name={name}
                    type="checkbox"
                    value={value}
                    onChange={() => {
                        helpers.setValue(!field.value);
                        onChange(!field.value);
                    }}
                    disabled={disabled}
                />{' '}
                {label}
            </label>
        </div>
    );
};

Checkbox.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
};

export default Checkbox;
